import {Button} from '@mui/material';
import React from 'react';
import {LockedStatusProp} from '../types';
import {Image} from '@jobseeker/lotus/components/Image';
import {Lock} from '@jobseeker/lotus/assets/icons';

interface Props {}

function LockedStatus(props: LockedStatusProp) {
  const {setShowStatusProMembershipPrompt} = props;
  const handleJobStatus = () => {
    setShowStatusProMembershipPrompt(true);
  };

  return (
    <Button
      onClick={handleJobStatus}
      variant="contained"
      sx={{
        fontSize: 12,
        mt: {xxs: 2, md: 0},
        height: 32,
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#333',
        color: 'white',
        borderRadius: 8,
        padding: '8px 12px',
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover': {
          backgroundColor: '#444',
          boxShadow: 'none',
        },
      }}
    >
      {/* Lock Icon */}
      <Image src={Lock} height={12} width={11} alt="lock" />
      &nbsp;Status Changed
    </Button>
  );
}

export default LockedStatus;
